import { authenticateUser } from '@services/auth/authDataService';
import { updateUser, updateCompany, updateCompanyOwner } from '@services/user/userDataService';
import { setCache, getCache, resetContactPerson, setSnackbar, currentLang } from '@/helpers';
import globalStoreActions from '@constans/store/global/globalStoreActions';
import userStoreActions from '@constans/store/user/userStoreActions';
import userStoreMutations from '@constans/store/user/userStoreMutations';
const actions = {
    async [userStoreActions.GET_USER]({ commit }) {
        await authenticateUser().then(response => {
            const cache = getCache();
            // Append user to cache
            cache.user = response.data;
            // Append user role
            cache.user.user_role = cache.user.roles[0];
            // Check contact person
            cache.user.contact_person = resetContactPerson(cache.user.contact_person);
            // Set cache
            setCache(cache);
            // Commit to store
            commit(userStoreMutations.SET_USER, cache.user);
        });
    },
    async [userStoreActions.UPDATE_USER]({ state, commit, dispatch }, opt) {
        const snackbar = {
            status: 'Success',
            message: currentLang === 'sv' ? 'Dina kontaktuppgifter sparades' : 'Contact information updated'
        };
        const payload = {
            agent_id: state.agent_id,
            ssn: state.ssn,
            email: state.email,
            first_name: state.first_name,
            last_name: state.last_name,
            phone: state.phone,
            cellphone: state.cellphone,
            street_address: state.street_address,
            street_number: state.street_number,
            coaddress: state.coaddress,
            zip: state.zip,
            city: state.city,
            non_swedish_postal_code: state.non_swedish_postal_code,
            contact_person: opt && opt.contact_person ? state.contact_person : null
        };
        const result = await updateUser(payload).then((response) => {
            if (response.status === 'Success') {
                const cache = getCache();
                // Append user to cache
                cache.user = response.data;
                // Check contact person
                cache.user.contact_person = resetContactPerson(cache.user.contact_person);
                // Set cache
                setCache(cache);
                // Commit to store
                commit(userStoreMutations.SET_USER, cache.user);
            }
            return response.status === 'Success';
        }).catch(err => {
            const errKeys = Object.keys(err.data);
            if (err.status === 'Error') {
                if (err.data) {
                    snackbar.status = err.status;
                    snackbar.message = err.data[errKeys[0]].length > 0 ? err.data[errKeys[0]][0] : err.message;
                }
            }
        });
        dispatch(`global/${globalStoreActions.SET_SNACKBAR}`, setSnackbar(snackbar), { root: true });
        return result;
    },
    async [userStoreActions.UPDATE_COMPANY]({ state }) {
        const payload = {
            name: state.company.name,
            organization_number: state.company.organization_number,
            industry: state.company.industry,
            department: state.company.department,
            street_address: state.company.street_address,
            street_number: state.company.street_number,
            zip: state.company.zip,
            city: state.company.city,
            country: state.company.country,
            switchboard_number: state.company.switchboard_number,
            signatory_first_name: state.company.signatory_first_name != '' ? state.company.signatory_first_name : null,
            signatory_last_name: state.company.signatory_last_name != '' ? state.company.signatory_last_name : null,
            signatory_phone: state.company.signatory_phone != '' ? state.company.signatory_phone : null,
            signatory_cellphone: state.company.signatory_cellphone != '' ? state.company.signatory_cellphone : null,
            signatory_email: state.company.signatory_email != '' ? state.company.signatory_email : null,
            notes: state.company.notes,
        };
        let allGood = true;
        const resultCompany = await updateCompany(payload).then((response) => {
            if (response.status === 'Success') {
                const cache = getCache();
                const data = response.data;
                cache.user.company = data.company;
                setCache(cache);
                return response;
            }
            else {
                allGood = false;
            }
        });
        if (!allGood) {
            return resultCompany;
        }
        const userPayload = {
            email: state.email,
            first_name: state.first_name,
            last_name: state.last_name,
            phone: state.phone,
            cellphone: state.cellphone,
        };
        const resultUser = await updateCompanyOwner(userPayload).then((response) => {
            if (response.status === 'Success') {
                // const cache = getCache()
                const data = response.data;
                // console.log(data.user);
                // cache.user = data.user
                // setCache(cache)
                return response;
            }
        });
        return resultUser;
    }
};
export default actions;
